export default "__VITE_ASSET__B2zE8eIF__"